import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

/**
 * Shared leave-confirmation dialog for unsaved changes.
 * Close value: `true` = Discard Changes, `false` = Stay on Page.
 */
@Component({
  selector: 'app-unsaved-changes-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrl: './unsaved-changes-dialog.component.scss',
})
export class UnsavedChangesDialogComponent {
  private readonly dialogRef = inject(
    MatDialogRef<UnsavedChangesDialogComponent, boolean>
  );

  onStay(): void {
    this.dialogRef.close(false);
  }

  onDiscard(): void {
    this.dialogRef.close(true);
  }
}
